import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiService from '../services/apiService';

const ManagePortfolios = () => {
  const [portfolios, setPortfolios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchPortfolios();
  }, []);

  const fetchPortfolios = async () => {
    try {
      setLoading(true);
      
      const data = await apiService.get('/portfolios');
      setPortfolios(data);
      setError(null);
    } catch (err) {
      console.error('Error fetching portfolios:', err);
      setError('Failed to load portfolios. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const handlePortfolioClick = (portfolioId) => {
    // Navigate to portfolio details page when implemented
    navigate(`/portfolios/${portfolioId}`);
  };

  const truncateDescription = (description, maxLength = 200) => {
    if (!description) return '';
    return description.length > maxLength 
      ? description.substring(0, maxLength) + '...' 
      : description;
  };

  if (loading) {
    return (
      <div className="manage-properties">
        <div className="page-header">
          <h1>Manage Portfolios</h1>
        </div>
        <div className="loading-state">
          <p>Loading portfolios...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="manage-properties">
        <div className="page-header">
          <h1>Manage Portfolios</h1>
        </div>
        <div className="error-state">
          <p>{error}</p>
          <button onClick={fetchPortfolios} className="retry-button">
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="manage-properties">
      <div className="page-header">
        <h1>Manage Portfolios</h1>
      </div>

      <div className="properties-table">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Title</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            {portfolios.map((portfolio) => (
              <tr key={portfolio.id}>
                <td>
                  <strong>{portfolio.id}</strong>
                </td>
                <td>
                  <a 
                    href="#"
                    className="property-link"
                    onClick={(e) => {
                      e.preventDefault();
                      handlePortfolioClick(portfolio.id);
                    }}
                    title="Click to edit portfolio details"
                  >
                    {portfolio.title}
                  </a>
                </td>
                <td>{truncateDescription(portfolio.description)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ManagePortfolios;
